import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { PotentialBookingsMutations } from '@sales-app/graphql/mutations/potentialBookings.mutations'
import { StatusQueries } from '@sales-app/graphql/queries/potentialBooking/status.queries'
import { usePotentialBookings } from '@sales-app/hooks/usePotentialBookings/usePotentialBookings'
import { Row } from '@tanstack/react-table'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { useAlertContext } from '@/context'
import { useGraphql, useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  rowSelected: Row<any>[]
}

export const UpdateStatusSelection = ({ rowSelected }: Props) => {
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const { refetch } = usePotentialBookings()
  const { setAlert } = useAlertContext()

  const { mutate } = useGraphqlMutation(PotentialBookingsMutations.updateStatusForPotentialBookings(), {
    onSuccess: () => {
      refetch()
      setAlert('Updated statuses successfully', 'success')
    },
  })

  const { data: statusQueryData, isLoading } = useGraphql<StatusQueries.GET_STATUSES.Response>(
    StatusQueries.getStatuses.name,
    StatusQueries.getStatuses(),
    {
      filter: {
        active: true,
        standard: true,
        corporateHousing: false,
      },
    },
  )

  const assignStatus = (id?: number) => {
    const selectedPotentialBookingIds = rowSelected.map((d) => d.original.id)

    setDropdownExpanded(false)
    if (selectedPotentialBookingIds && selectedPotentialBookingIds.length && id) {
      mutate({
        potentialBookingIds: selectedPotentialBookingIds,
        potentialBookingStatusId: id,
      })
    }
  }

  return (
    <>
      <Dropdown
        className="mr-4 hidden w-full md:w-auto lg:flex"
        expanded={dropdownExpanded}
        headerTitle="Update Status"
        onHideDropdown={() => setDropdownExpanded(false)}
        renderHeader={() => <div></div>}
        setExpanded={setDropdownExpanded}
      >
        <AssignFilterOptionsStyled>
          <div className="flex w-full">
            {isLoading ? (
              <div className="flex h-24 w-full items-center justify-center">
                <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
              </div>
            ) : (
              <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
                {statusQueryData && statusQueryData?.potentialBookingStatuses?.length && (
                  <ul>
                    {statusQueryData?.potentialBookingStatuses.map((status) => (
                      <li key={status.id} onClick={() => assignStatus(status.id)} role={'presentation'}>
                        {status.description}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </AssignFilterOptionsStyled>
      </Dropdown>
    </>
  )
}

export const AssignFilterOptionsStyled = styled.div`
  width: 13rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    margin-bottom: 0.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
